import React from "react";
import './SpiderNav.scss';


const SpiderNav  = ({
  activeLabel,
  labelsLength,
  updateLabel,
  spiderLabelClick,
  labelArray,
  ...props
}) => {

    const nextCap=()=>{
        let currI =activeLabel;
        let lab=activeLabel+1;
        if(lab==labelsLength){
          lab=0
        }
        let labelText=labelArray[lab];
        let nextI=currI+1;
        if(currI==(labelsLength-1)){
          nextI=0;
        }
        updateLabel(nextI);
        spiderLabelClick(labelText); 
      }

      const  prevCap=()=>{
        let currI =activeLabel;
        let lab=activeLabel-1;
        if(lab==-1){
          lab=(labelsLength-1);
        }
        let labelText=labelArray[lab];
        let prevI=currI-1
        if(currI==0){
          prevI=labelsLength-1;
        }
       updateLabel(prevI);
       spiderLabelClick(labelText); 
      }
        return (
          <div className="SpiderNav">
          <div className="SpiderNav-bttn SpiderNav-bttn-prev"onClick={prevCap} tabindex="4"> </div>
          <div className="SpiderNav-txt">Use the arrows or links on the chart to navigate through the capabilities
          </div>
          <div className="SpiderNav-bttn SpiderNav-bttn-next" onClick={nextCap} tabindex="5"></div>
     </div>
        )
    }


export default SpiderNav;